import React from "react";
import { Grid, Typography } from "@sumprio/ui";

type DocxPreviewPanelProps = {
  loading: boolean;
  error: boolean;
  content: string | null;
  classNamePrefix: "view-document-modal" | "view-attachment-modal";
};

export function DocxPreviewPanel({
  loading,
  error,
  content,
  classNamePrefix,
}: DocxPreviewPanelProps) {
  if (loading) {
    return (
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding="2xl"
      >
        <Typography variant="body" bodySize="md" bodyWeight="regular" color="secondary">
          Loading…
        </Typography>
      </Grid>
    );
  }

  if (error || content === null) {
    return (
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="md"
        padding="2xl"
        className={`${classNamePrefix}__fallback`}
      >
        <Typography variant="body" bodySize="md" bodyWeight="regular" color="secondary">
          Could not load Word preview. You can still try downloading.
        </Typography>
      </Grid>
    );
  }

  const paragraphs = content.split("\n");

  return (
    <div className={`${classNamePrefix}__docx-preview`}>
      {paragraphs.map((paragraph, index) => (
        <p key={`docx-p-${index}`}>{paragraph || "\u00a0"}</p>
      ))}
    </div>
  );
}
